import React from 'react';
import './CompanyViewerFields.css';

export interface CompanyViewerValue {
  email: string;
}

export const EMPTY_VIEWER: CompanyViewerValue = { email: '' };

export const VIEWER_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

interface Props {
  value: CompanyViewerValue;
  onChange: (next: CompanyViewerValue) => void;
  errors?: Record<string, string>;
  disabled?: boolean;
}

// Shared by the New Auction form and the "Company viewer" card on an existing
// auction, so both validate and look the same.
const CompanyViewerFields: React.FC<Props> = ({ value, onChange, errors = {}, disabled }) => {
  const set = (patch: Partial<CompanyViewerValue>) => onChange({ ...value, ...patch });

  return (
    <div className="cv-grid">
      <div className="cv-field">
        <label>
          Email<span className="cv-required">*</span>
        </label>
        <input
          type="email"
          maxLength={254}
          value={value.email}
          disabled={disabled}
          onChange={(e) => set({ email: e.target.value.replace(/\s/g, '') })}
          placeholder="Email address they log in with"
          className={errors.email ? 'cv-error' : ''}
        />
        {errors.email && <p className="cv-error-text">{errors.email}</p>}
      </div>
    </div>
  );
};

export default CompanyViewerFields;
